module.exports = __webpack_public_path__ + "img/saas1-news.c8025f6f.png";